<template>
  <section>
    <b-overlay
      :show="loading"
      no-center
      variant="transparent"
      rounded="sm"
    >
      <template #overlay>
        <loading-spinner />
      </template>
      <b-row>
        <b-col
          cols="12"
          offset-lg="3"
          offset-md="2"
          md="8"
          lg="6"
        >
          <div class="video-room-setup-container">
            <div class="setup-form">
              <!-- Stream Title -->
              <div class="form-group">
                <label>{{ $t('Stream title') }}</label>
                <b-form-input
                  v-model="form.streamTitle"
                  :placeholder="$t('Hey, join us! 😊')"
                  class="stream-title-input"
                  maxlength="100"
                />
                <small class="text-muted d-block mt-1">{{ form.streamTitle.length }}/100</small>
              </div>

              <!-- Goal Types -->
              <div class="form-group">
                <label>{{ $t('Choose your goal types') }}</label>
                <div class="text-muted small mb-2">{{ $t('You can select diamond or gift') }}</div>
                <div class="goal-types">
                  <div 
                    class="goal-type-option"
                    :class="{ 'active': form.streamGoal.goalType === 1 }"
                    @click="setGoalType(1)"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="32px" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"/></svg> {{ $t('Diamond') }}
                  </div>
                  <!-- Hediye satışı kaldırıldı — hediye tipli yayın hedefi seçilemez -->
                  <div
                    v-if="false"
                    class="goal-type-option"
                    :class="{ 'active': form.streamGoal.goalType === 2 }"
                    @click="setGoalType(2)"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="32"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M190.5 68.8L225.3 128l-1.3 0-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40zM32 288l0 176c0 26.5 21.5 48 48 48l144 0 0-224L32 288zM288 512l144 0c26.5 0 48-21.5 48-48l0-176-192 0 0 224z"/></svg> {{ $t('Gift') }}
                  </div>
                </div>
              </div>

              <!-- Goal Amount -->
              <div class="form-group">
                <label>{{ $t('Choose your goal') }}</label>
                <div class="text-muted small mb-2">{{ $t('You should choose minimum one goal to start') }}</div>
                
                <!-- Diamond Input -->
                <template v-if="form.streamGoal.goalType === 1">
                  <b-form-input
                    v-model.number="form.streamGoal.goalTarget"
                    type="number"
                    min="0"
                    placeholder="0"
                    class="goal-amount-input mb-2"
                  />
                  <input
                    type="range"
                    v-model.number="form.streamGoal.goalTarget"
                    min="0"
                    max="100000"
                    step="1000"
                    class="custom-range w-100"
                  />
                  <div class="d-flex justify-content-between small text-muted mt-1">
                    <span>0</span>
                    <span>{{ form.streamGoal.goalTarget.toLocaleString() }}</span>
                    <span>100,000</span>
                  </div>
                </template>

                <!-- Gift Selection -->
                <template v-else>
                  <v-select
                    v-model="selectedGift"
                    :options="gifts"
                    label="label"
                    :reduce="gift => gift.productId"
                    class="gift-select"
                  >
                    <template #option="{ label, credits, image }">
                      <div class="d-flex align-items-center gap-2">
                        <img :src="image" width="24" height="24" class="gift-icon" />
                        <div>
                          <div>{{ label }}</div>
                          <small class="text-muted">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"/></svg>
                            {{ credits.toLocaleString() }}
                          </small>
                        </div>
                      </div>
                    </template>
                    <template #selected-option="{ label, credits, image }">
                      <div class="d-flex align-items-center gap-2">
                        <img :src="image" width="24" height="24" class="gift-icon" />
                        <div>
                          <div>{{ label }}</div>
                          <small class="text-muted">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"/></svg>
                            {{ credits.toLocaleString() }}
                          </small>
                        </div>
                      </div>
                    </template>
                  </v-select>

                  <!-- Gift Quantity Slider (NEW) -->
                  <div v-if="selectedGift" class="mt-3">
                    <label>{{ $t('Set Gift Quantity Goal') }}</label>
                     <input
                        type="range"
                        v-model.number="form.streamGoal.goalTarget"
                        min="1"
                        max="20"
                        step="1"
                        class="custom-range w-100"
                      />
                      <div class="d-flex justify-content-between small text-muted mt-1">
                        <span>1</span>
                        <span>{{ form.streamGoal.goalTarget }}</span>
                        <span>20</span>
                      </div>
                  </div>
                  <!-- End Gift Quantity Slider -->
                </template>
              </div>

              <!-- Start Stream Button -->
              <div class="text-center mt-4">
                <b-button
                  variant="primary"
                  class="start-stream-btn"
                  :disabled="!isFormValid || loading"
                  @click="startStream"
                >
                  {{ $t('Start Stream') }}
                </b-button>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-overlay>
  </section>
</template>

<script>
import {
  BButton,
  BCol,
  BFormInput,
  BOverlay,
  BRow,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import useJwt from '@/auth/jwt/useJwt'
import { showNotify, throwDefaultError } from '@/helpers/helpers'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'VideoRoomSetup',
  components: {
    BButton,
    BCol,
    BFormInput,
    BOverlay,
    BRow,
    vSelect,
  },
  data() {
    return {
      loading: false,
      selectedGift: null,
      form: {
        streamTitle: '',
        streamGoal: {
          goalType: 2, // 1 = Diamonds, 2 = Gift
          goalTarget: 0,
          giftProductId: null
        },
        maxNbOfSpeakers: 5,
      },
      gifts: [],
    }
  },
  created() {
    // Hediye satışı kaldırıldı
    // this.fetchGifts()
  },
  watch: {
    selectedGift(newVal) {
      if (newVal) {
        this.form.streamGoal.giftProductId = newVal
        // Reset target quantity to 1 when a new gift is selected
        this.form.streamGoal.goalTarget = 1;
      } else {
        // Clear product ID and target if gift is deselected
        this.form.streamGoal.giftProductId = null;
        this.form.streamGoal.goalTarget = 0;
      }
    }
  },
  computed: {
    isFormValid() {
      const isTitleValid = this.form.streamTitle.length > 0 && this.form.streamTitle.length <= 100
      // const isSpeakersValid = this.form.maxNbOfSpeakers > 0 && this.form.maxNbOfSpeakers <= 10 // Speaker count is now fixed

      if (this.form.streamGoal.goalType === 1) { // Diamond
        return isTitleValid && this.form.streamGoal.goalTarget > 0
      }
      
      // Gift: Check title, selected gift, and quantity > 0
      return isTitleValid && this.form.streamGoal.giftProductId !== null && this.form.streamGoal.goalTarget > 0
    },
    ...mapState('videoRoom', ['roomInfo', 'isHost', 'isMuted'])
  },
  methods: {
    ...mapActions('videoRoom', [
      'setRoomInfo',
      'setAgoraClient',
      'setLocalAudioTrack',
      'setIsHost',
      'setIsMuted'
    ]),
    fetchGifts() {
      this.loading = true
      useJwt.getVideoRoomGifts()
        .then(response => {
          if (response.data && response.data.body) {
            
            this.gifts = response.data.body.map(gift => {
              try {
                const mappedGift = {
                  productId: gift.productId,
                  label: gift.label,
                  credits: gift.credits,
                  image: require(`@/assets/images/gifts/${gift.image}`)
                }
                return mappedGift
              } catch (error) {
                console.warn(`Could not load image for gift ${gift.label}:`, error)
                // Eğer görsel yüklenemezse varsayılan bir görsel kullan
                return {
                  productId: gift.productId,
                  label: gift.label,
                  credits: gift.credits,
                  image: require('@/assets/images/gifts/gift.svg') // Varsayılan görsel
                }
              }
            })
          }
        })
        .catch(error => {
          console.error('Error fetching gifts:', error)
          throwDefaultError(this.$toast, error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setGoalType(type) {
      this.form.streamGoal.goalType = type
      if (type === 2) { // Gift seçildiğinde
        this.form.streamGoal.giftProductId = null
        this.selectedGift = null
        // Set default gift quantity goal to 1
        this.form.streamGoal.goalTarget = 1;
      } else { // Diamond seçildiğinde
        this.form.streamGoal.giftProductId = null
        // Reset diamond goal to 0 when switching
        this.form.streamGoal.goalTarget = 0;
      }
    },
    async startStream() {
      if (!this.form.streamTitle) {
        this.$toast({
          title: 'Error',
          text: 'Please enter a room name',
          variant: 'danger'
        })
        return
      }

      this.loading = true
      const payload = {
        streamTitle: this.form.streamTitle,
        streamGoal: this.form.streamGoal,
        maxNbOfSpeakers: this.form.maxNbOfSpeakers
      }

      useJwt.publishVideoRoom(payload)
        .then(response => {
          if (response.data && response.data.body) {
            const roomInfo = {
              channelId: response.data.body.channelId,
              channelName: response.data.body.channelName,
              agoraUid: response.data.body.agoraUid,
              rtcToken: response.data.body.rtcToken,
              heartbeatIntervalInSecs: response.data.body.heartbeatIntervalInSecs,
              nudityCheckIntervalInSecs: response.data.body.nudityCheckIntervalInSecs,
              multiStream: response.data.body.multiStream,
              relayedUsers: response.data.body.relayedUsers,
              mainPublisherUuid: this.$store.getters['auth/userId'],
              privateRoom: response.data.body.privateRoom,
              premiumRoom: response.data.body.premiumRoom,
              psrInfo: response.data.body.psrInfo,
              isHost: true
            }
            this.setRoomInfo(roomInfo)
            this.$router.push({
              name: 'video-room', 
              params: {
                channelId: response.data.body.channelId,
                agoraUid: response.data.body.agoraUid 
              }
            });
          }
        })
        .catch(error => {
          const errorCode = error.response?.data?.header?.error?.errorCode
          let errorMessage = 'An unknown error occurred'

          switch (errorCode) {
            case 218:
              errorMessage = 'Your voice is turned off'
              break
            case 2901:
              errorMessage = 'An unknown error occurred, please contact support'
              break
            case 2918:
              errorMessage = 'You are already publishing a stream'
              break
            case 2919:
              errorMessage = 'Stream title can not be empty'
              break
            case 2920:
              errorMessage = 'Stream title can not be longer than 100 characters'
              break
            case 2928:
              errorMessage = 'You are already in a call'
              break
            case 3501:
              errorMessage = 'You have to define max number of speakers'
              break
          }

          this.$toast({
            title: this.$t('Error'),
            text: this.$t(errorMessage),
            variant: 'danger'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.video-room-setup-container {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  padding: 20px;
  margin-bottom: 24px;

  .setup-form {
    .form-group {
      margin-bottom: 24px;

      label {
        display: block;
        font-weight: 600;
        margin-bottom: 8px;
      }
    }
  }

  .stream-title-input {
    border-radius: 8px;
    border: 1px solid #E6E6E6;
    padding: 12px;
    font-size: 16px;
  }

  .goal-types {
    display: flex;
    gap: 12px;

    .goal-type-option {
      flex: 1;
      padding: 12px;
      border: 1px solid #E6E6E6;
      border-radius: 8px;
      text-align: center;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      &.active {
        background-color: #F8F2FF;
        border-color: #A644FB;
        color: #A644FB;
      }
    }
  }

  .goal-amount-input {
    border-radius: 8px;
    border: 1px solid #E6E6E6;
    padding: 12px;
    font-size: 16px;
  }

  .custom-range {
    -webkit-appearance: none;
    width: 100%;
    height: 8px;
    border-radius: 4px;
    background: #F8F2FF;
    outline: none;
    padding: 0;
    margin: 0;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #A644FB;
      cursor: pointer;
      border: none;
    }

    &::-moz-range-thumb {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #A644FB;
      cursor: pointer;
      border: none;
    }

    &::-ms-thumb {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #A644FB;
      cursor: pointer;
      border: none;
    }

    &::-webkit-slider-runnable-track {
      width: 100%;
      height: 8px;
      cursor: pointer;
      background: #F8F2FF;
      border-radius: 4px;
    }

    &::-moz-range-track {
      width: 100%;
      height: 8px;
      cursor: pointer;
      background: #F8F2FF;
      border-radius: 4px;
    }

    &::-ms-track {
      width: 100%;
      height: 8px;
      cursor: pointer;
      background: #F8F2FF;
      border-radius: 4px;
    }
  }

  .gift-select {
    ::v-deep .vs__dropdown-toggle {
      border-radius: 8px;
      border: 1px solid #E6E6E6;
      padding: 12px;
    }

    ::v-deep .vs__selected {
      margin: 0;
      padding: 0;
    }

    ::v-deep .vs__search {
      margin: 0;
      padding: 0;
    }

    ::v-deep .vs__dropdown-menu {
      border-radius: 8px;
      border: 1px solid #E6E6E6;
      padding: 12px;
    }

    ::v-deep .vs__dropdown-option {
      padding: 12px;
      border-radius: 8px;
      margin-bottom: 4px;

      &:hover {
        background-color: #F8F2FF;
      }
    }

    ::v-deep .vs__dropdown-option--highlight {
      background-color: #F8F2FF !important;
      color: #A644FB !important;
    }

    ::v-deep .d-flex {
      gap: 16px;
    }

    ::v-deep .gift-icon {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }

    ::v-deep .text-muted {
      margin-top: 4px;
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }

  .start-stream-btn {
    background: linear-gradient(45deg, #9C27B0, #E91E63);
    border: none;
    padding: 12px 40px;
    border-radius: 25px;
    font-weight: 600;
    font-size: 16px;

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
}

@media (max-width: 767.98px) {
  .video-room-setup-container {
    border-radius: 0;
    margin-bottom: 16px;
    margin-left: -15px;
    margin-right: -15px;
    width: calc(100% + 30px);
  }
}
</style> 